import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=7f8348ee"
import script from "./Option.vue?vue&type=script&lang=ts"
export * from "./Option.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports